var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import useDownload from '../../../hooks/useDownload';
import DownloadIconWithtext from '../../atoms/DownloadIconWithtext';
import ShippingInstructionDownloadIcon from './ShippingInstructionDownloadIcon';
import { useTranslation } from 'react-i18next';
import SelectBankAccountDialog from './SelectBankAccountDialog';
import { useNotify } from '../../../hooks/notificationHook';
import { salesContract as api } from '../../../api';
import { useRequest } from '../../../hooks/requestHook';
import { useNavigate } from 'react-router-dom';
var ContractsList = function (_a) {
    var _b = _a.offerList, salesContract = _b.salesContract, _c = _b.shippingInstructions, shippingInstructions = _c === void 0 ? [] : _c, producer = _b.producer;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var update = useRequest(api.update);
    var _d = React.useState(false), loading = _d[0], setLoading = _d[1];
    var notify = useNotify();
    var _e = React.useState(false), dialogOpen = _e[0], setDialogOpen = _e[1];
    var salesContractDownload = useDownload({
        path: "/api/sales_contracts/".concat(salesContract === null || salesContract === void 0 ? void 0 : salesContract.id, ".pdf"),
        downloadFilename: "sales_contract_#".concat(salesContract === null || salesContract === void 0 ? void 0 : salesContract.id, ".pdf"),
    });
    var auctionBonusInvoiceDownload = useDownload({
        path: "/api/sales_contracts/".concat(salesContract === null || salesContract === void 0 ? void 0 : salesContract.id, "/auction_bonus_invoice.pdf"),
        downloadFilename: "auction_bonus_invoice_#".concat(salesContract === null || salesContract === void 0 ? void 0 : salesContract.id, ".pdf"),
    });
    var hasSalesContract = React.useMemo(function () {
        if (!salesContract)
            return false;
        return salesContract && salesContract.status === 'published';
    }, [salesContract]);
    var hasAuctionOffer = React.useMemo(function () {
        if (!salesContract)
            return false;
        return salesContract.items.some(function (item) { return item.orderType === 'auction'; });
    }, [salesContract]);
    var salesContractHasProducerBankAccount = React.useMemo(function () { return Boolean(hasSalesContract && (salesContract === null || salesContract === void 0 ? void 0 : salesContract.producerBankAccount)); }, [hasSalesContract, salesContract === null || salesContract === void 0 ? void 0 : salesContract.producerBankAccount]);
    var onSubmit = React.useCallback(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!salesContract)
                        return [2 /*return*/];
                    setLoading(true);
                    return [4 /*yield*/, update({
                            id: salesContract.id,
                            sales_contract: data,
                        })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.updateSuccess')]);
                    navigate("/producer");
                    return [2 /*return*/];
            }
        });
    }); }, [salesContract, update, navigate, notify, t]);
    if (!hasSalesContract && shippingInstructions.length === 0) {
        return React.createElement("div", null, t('labels.noData'));
    }
    return (React.createElement("div", null,
        hasSalesContract && (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { onClick: salesContractHasProducerBankAccount
                    ? salesContractDownload.handleDownload
                    : function () { return setDialogOpen(true); }, disabled: salesContractDownload.downloading },
                React.createElement(DownloadIconWithtext, { title: "Sales contract" })),
            hasAuctionOffer && salesContractHasProducerBankAccount && (React.createElement(IconButton, { onClick: auctionBonusInvoiceDownload.handleDownload, disabled: auctionBonusInvoiceDownload.downloading },
                React.createElement(DownloadIconWithtext, { title: "Auction bonus invoice" }))))),
        shippingInstructions.length > 0 && (React.createElement(React.Fragment, null,
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h3" }, "Shipping instruction"),
                shippingInstructions.map(function (shippingInstruction) { return (React.createElement(ShippingInstructionDownloadIcon, { key: shippingInstruction.id, type: "shippingInstruction", shippingInstruction: shippingInstruction })); })),
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h3" }, "Commercial Invoice"),
                shippingInstructions.map(function (shippingInstruction) { return (React.createElement(ShippingInstructionDownloadIcon, { key: shippingInstruction.id, type: "commercialInvoice", shippingInstruction: shippingInstruction })); })),
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h3" }, "Packing List"),
                shippingInstructions.map(function (shippingInstruction) { return (React.createElement(ShippingInstructionDownloadIcon, { key: shippingInstruction.id, type: "packingList", shippingInstruction: shippingInstruction })); })))),
        React.createElement(SelectBankAccountDialog, { open: dialogOpen, onClose: function () { return setDialogOpen(false); }, producer: producer, onSubmit: onSubmit, loading: loading })));
};
export default ContractsList;
